import React, { useEffect, useState } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { ManageBranchService } from "../api/services";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { Modal, Button, Table } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const Organization = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const isAd = searchParams.get("isAd") === "true";
  const navigate = useNavigate();
  const [orgDetails, setOrgDetails] = useState(null);
  const [branches, setBranches] = useState([]);
  const [IsLoading, setIsLoading] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  // Transactions Modal
  const [showTransactionsModal, setShowTransactionsModal] = useState(false);
  const [showOrgStatisticsticalModal,  setshowOrgStatisticsticalModal] = useState(false);
  const [OrgTransactions, setOrgTransactions] = useState([]);
  const [year, setYear] = useState(new Date().getFullYear());

  const [showModal, setShowModal] = useState(false);
  const [branchForm, setBranchForm] = useState({
    branch_name: "",
    address_1: "",
    address_2: "",
    district: "",
    state: "",
  });
  const [errors, setErrors] = useState({});
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deletePurpose, setDeletePurpose] = useState("");
  const [activeTab, setActiveTab] = useState("daily"); // "daily" | "monthly" | "yearly"
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [OrgTransactionsDaily, setOrgTransactionsDaily] = useState([]);
  const [OrgTransactionsMonthly, setOrgTransactionsMonthly] = useState([]);
  const [OrgTransactionsYearly, setOrgTransactionsYearly] = useState([]);
  const [OrgStatisticsDate, setOrgStatisticsDate] = useState([]);
  // Handle branch form input
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setBranchForm({ ...branchForm, [name]: value });
  };
   // OrgStatistics 
   const fetchOrgStatisticsYearly = () => {
      const payload = {
        id: parseInt(id)
      }; 
      setIsLoading(true);
      ManageBranchService.GetOrgStatistics(payload)
        .then((res) => {
          setOrgStatisticsDate(res.data.results || []);
        })
        .catch((err) => {
          console.error("Failed to fetch yearly transactions:", err);
          setOrgStatisticsDate([]);
        })
        .finally(() => setIsLoading(false));
   };

  // ---------- Transactions ----------
  // Fetch Monthly Transactions

 // Fetch Yearly Transactions
const fetchOrgTransactionsYearly = (year) => {
  const payload = {
    id: parseInt(id),
    mode: "year",
    time: year.toString(), // YYYY
  };
  setIsLoading(true);
  ManageBranchService.GetOrgTransactions(payload)
    .then((res) => {
      setOrgTransactionsYearly(res.data.results || []);
    })
    .catch((err) => {
      console.error("Failed to fetch yearly transactions:", err);
      setOrgTransactionsYearly([]);
    })
    .finally(() => setIsLoading(false));
};
  const fetchOrgTransactionsDaily = (date) => {
    const payload = {
        id: parseInt(id),
        mode: "date",
        time: date.toISOString().split("T")[0], // YYYY-MM-DD
    };
    setIsLoading(true);
    ManageBranchService.GetOrgTransactions(payload)
        .then((res) => {
        setOrgTransactionsDaily(res.data.results || []);
        setIsLoading(false);
        })
        .catch((err) => {
        console.error("Failed to fetch daily transactions:", err);
        setOrgTransactionsDaily([]);
        setIsLoading(false);
        });
    };


// Fetch Monthly Transactions
const fetchOrgTransactionsMonthly = (date) => {
    const payload = {
    id: parseInt(id),
    mode: "month",
    time: `${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}` // MM-yyyy
    };

  setIsLoading(true);
  ManageBranchService.GetOrgTransactions(payload)
    .then((res) => {
      setOrgTransactionsMonthly(res.data.results || []);
      setIsLoading(false);
    })
    .catch((err) => {
      console.error("Failed to fetch monthly transactions:", err);
      setOrgTransactionsMonthly([]);
      setIsLoading(false);
    });
};

// Show Modal and fetch default tab
const showOrgTransactionModal = () => {
  if (activeTab === "daily") fetchOrgTransactionsDaily(selectedDate);
  else if (activeTab === "monthly") fetchOrgTransactionsMonthly(selectedDate);
  else fetchOrgTransactionsYearly(selectedDate.getFullYear());
  setShowTransactionsModal(true);
};
const showOrgStatisticsModal = () => {
  setshowOrgStatisticsticalModal(true)
  fetchOrgStatisticsYearly()
}
const changeDate = (direction) => {
  const newDate = new Date(selectedDate);

  if (activeTab === "daily") {
    newDate.setDate(selectedDate.getDate() + direction);
    setSelectedDate(newDate);
    fetchOrgTransactionsDaily(newDate);
  } else if (activeTab === "monthly") {
    newDate.setMonth(selectedDate.getMonth() + direction);
    setSelectedDate(newDate);
    fetchOrgTransactionsMonthly(newDate);
  } else if (activeTab === "yearly") {
    const newYear = selectedDate.getFullYear() + direction;
    newDate.setFullYear(newYear);
    setSelectedDate(newDate);
    fetchOrgTransactionsYearly(newYear);
  }
};


const handleTabChange = (tab) => {
  setActiveTab(tab);

  const today = new Date();

  if (tab === "daily") {
    setSelectedDate(today);
    fetchOrgTransactionsDaily(today);
  } else if (tab === "monthly") {
    setSelectedDate(today); // month is taken from selectedDate
    fetchOrgTransactionsMonthly(today);
  } else if (tab === "yearly") {
    setSelectedDate(today); // year is taken from selectedDate
    fetchOrgTransactionsYearly(today.getFullYear());
  }
};

//   const showOrgTransactionModal = () => {
//     fetchOrgTransactionsYearly(year);
//     setShowTransactionsModal(true);
//   };

  const changeYear = (direction) => {
    const newYear = year + direction;
    setYear(newYear);
    fetchOrgTransactionsYearly(newYear);
  };

  // ---------- Validation ----------
  function Validation(branchForm) {
    const errors = {};
    let validationFlag = true;

    if (branchForm.branch_name === "") {
      errors.name = "Branch Name is required";
      validationFlag = false;
    }
    if (branchForm.address_1 === "") {
      errors.address1 = "Address Line 1 is required!";
      validationFlag = false;
    }
    if (branchForm.address_2 === "") {
      errors.address2 = "Address Line 2 is required!";
      validationFlag = false;
    }
    if (branchForm.district === "") {
      errors.district = "District is required!";
      validationFlag = false;
    }
    if (branchForm.state === "") {
      errors.state = "State is required!";
      validationFlag = false;
    }
    errors.validationFlag = validationFlag;
    return errors;
  }

  ///submit new branch data
  const handleBranchSubmit = (e) => {
    e.preventDefault();
    const errorMsg = Validation(branchForm);
    setErrors(errorMsg);
    if (errorMsg.validationFlag) {
      const BASE_URL_AddBranch = window.BASE_URL + "/add_branch";
      const data = JSON.stringify({
        ...branchForm,
        organization_id: parseInt(id),
      });
      const token = localStorage.getItem("jwtToken");
      const config_Addbranch = {
        method: "post",
        url: BASE_URL_AddBranch,
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
        maxBodyLength: Infinity,
        data: data,
      };
      setIsLoading(true);
      axios
        .request(config_Addbranch)
        .then((response) => {
          if (response?.data) {
            setShowModal(false);
            alert("Branch Added Successfully!");

            // Refresh branches
            const BASE_URL_BRANCHES_BY_ID = window.BASE_URL + "/get_branches";
            const databranch = JSON.stringify({
              organization_id: parseInt(id),
            });
            const config_branch = {
              method: "post",
              url: BASE_URL_BRANCHES_BY_ID,
              headers: {
                Authorization: "Bearer " + token,
                "Content-Type": "application/json",
              },
              maxBodyLength: Infinity,
              data: databranch,
            };

            axios
              .request(config_branch)
              .then((response) => {
                if (response?.data) {
                  if (response.data.code === 200) {
                    setBranches(response.data.results);
                  } else if (response.data.code === 201) {
                    setBranches([]);
                  }
                  setIsLoading(false);
                }
              })
              .catch((error) => {
                console.error("Error fetching organization info:", error);
                setIsLoading(false);
              });
          }
        })
        .catch((error) => {
          console.error("Error adding branch:", error);
        });

      setBranchForm({
        branch_name: "",
        address_1: "",
        address_2: "",
        district: "",
        state: "",
      });
    }
  };

  // ---------- Delete Organization ----------
  const handleDelete = () => {
    if (deletePurpose.trim() === "") {
      alert("Please enter a reason for deletion.");
      return;
    }

    const dataDelete = JSON.stringify({
      id: parseInt(id),
      role: 3,
      description: deletePurpose.trim(),
    });
    const BASE_URL_Delete_Org = window.BASE_URL + "/delete_user";
    const token = localStorage.getItem("jwtToken");
    const config_deleteOrg = {
      method: "post",
      url: BASE_URL_Delete_Org,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      maxBodyLength: Infinity,
      data: dataDelete,
    };
    setIsLoading(true);
    axios
      .request(config_deleteOrg)
      .then((response) => {
        if (response?.data?.code === 200) {
          setIsLoading(false);
          navigate("/SuperAdmin/ManageOrganization");
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error while deleting organization info:", error);
      });
  };

  // ---------- Fetch Organization Info + Branches ----------
  useEffect(() => {
    const token = localStorage.getItem("jwtToken");
    if (!token) {
      navigate("/");
      return;
    }
    const BASE_URL = window.BASE_URL + "/get_organizationinfo";
    const BASE_URL_BRANCHES_BY_ID = window.BASE_URL + "/get_branches";
    const data = JSON.stringify({
      organization_id: parseInt(id),
    });
    const config = {
      method: "post",
      url: BASE_URL,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      maxBodyLength: Infinity,
      data: data,
    };

    const config_branch = {
      method: "post",
      url: BASE_URL_BRANCHES_BY_ID,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      maxBodyLength: Infinity,
      data: data,
    };
    setIsLoading(true);
    axios
      .request(config)
      .then((response) => {
        if (response?.data) {
          setOrgDetails(response.data.results[0]);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching organization info:", error);
        setIsLoading(false);
      });

    setIsLoading(true);
    axios
      .request(config_branch)
      .then((response) => {
        if (response?.data) {
          if (response.data.code === 200) {
            setBranches(response.data.results);
          } else if (response.data.code === 201) {
            setBranches([]);
          }
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching branches:", error);
        setIsLoading(false);
      });
  }, [id, navigate]);

  // ---------- Calculate Organization Totals ----------
 const totals = (activeTab === "daily"
  ? OrgTransactionsDaily
  : activeTab === "monthly"
  ? OrgTransactionsMonthly
  : OrgTransactionsYearly
).reduce(
  (acc, t) => {
    acc.recharge_count += t.recharge_count || 0;
    acc.recharge_amount += t.recharge_amount || 0;
    acc.calls_count += t.calls_count || 0;
    acc.callcharge += t.callcharge || 0;
    return acc;
  },
  { recharge_count: 0, recharge_amount: 0, calls_count: 0, callcharge: 0 }
);
  // ---------- Calculate Organization Totals ----------


  return (
    <div className="container mt-4">
      {/* Loader */}
      <div
        className="loader"
        style={IsLoading ? {} : { display: "none" }}
      >
        <div className="lds-spinner">
          <div></div><div></div><div></div><div></div><div></div><div></div>
          <div></div><div></div><div></div><div></div><div></div><div></div>
        </div>
      </div>
        <button
          className="btn btn-outline-secondary mb-3"
          onClick={() => navigate(-1)}
        >
          ← Back
        </button>
      {/* Header */}
      <div className="CommonColor text-white text-white p-3 rounded-top shadow-sm">
       
        <h4 className="mb-0">Organization Details</h4>
      </div>

      {/* Org Details */}
      <div>
        {!orgDetails ? (
          <p>Loading...</p>
        ) : (
          <div className="card p-3">
            <p><strong>Name:</strong> {orgDetails.name}</p>
            <p><strong>Email:</strong> {orgDetails.email}</p>
            <p><strong>Mobile 1:</strong> {orgDetails.mobile_1}</p>
            <p><strong>Mobile 2:</strong> {orgDetails.mobile_2}</p>
            <p><strong>Address:</strong> {orgDetails.address_1}, {orgDetails.address_2}</p>
            <div className="d-flex gap-2">
              <button
                className="btn CommonColor text-white"
                onClick={() => showOrgTransactionModal()}
              >
                Transactions
              </button>
              <button
                className="btn CommonColor text-white"
                onClick={() => showOrgStatisticsModal()}
              >
                Statistics
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Branches List */}
      <div className="container mt-4">
        <div className="d-flex justify-content-between align-items-center mb-3 gap-2">
          <h4 className="mb-0">Branches</h4>
          <div className="d-flex gap-2">
            <button
              className="btn btn-danger"
              onClick={() => setShowDeleteModal(true)}
            >
              Delete Organization
            </button>
            <button
              className="btn btncommonColor text-white"
              onClick={() => setShowModal(true)}
            >
              Add Branch
            </button>
          </div>
        </div>
        <div className="card p-4 mt-3 shadow-sm">
          <table className="table-hover">
            <thead className="">
              <tr className="theadtrStyle">
                              <th className="thStyle text-center">Branch Name</th>
                              <th className="thStyle text-center">Address 1</th>
                              <th className="thStyle text-center">Address 2</th>
                              <th className="thStyle text-center">District</th>
                              <th className="thStyle text-center">State</th>
              </tr>
            </thead>
            <tbody>
              {branches.length === 0 ? (
                <tr>
                  <td colSpan="5" className="text-center text-danger">
                    No branches found for this organization.
                  </td>
                </tr>
              ) : (
                branches.map((branch, index) => (
                  <tr
                    key={index}
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      navigate(
                        `/SuperAdmin/ManageBranch/${branch.branch_id}/${id}?isAd=${isAd}`
                      )
                    }
                  >
                    <td className="tdStyle text-center">{branch.branch_name}</td>
                    <td className="tdStyle text-center">{branch.address_1}</td>
                    <td className="tdStyle text-center">{branch.address_2}</td>
                    <td className="tdStyle text-center">{branch.district}</td>
                    <td className="tdStyle text-center">{branch.state}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

    

      <Modal
        show={showTransactionsModal}
        onHide={() => setShowTransactionsModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton className="CommonColor text-white">
          <Modal.Title>Organization Transactions</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* Tabs */}
          <div className="d-flex justify-content-center mb-3 gap-3">
            <button
              className={`btn ${activeTab === "daily" ? "CommonColor text-white" : "btn-light"}`}
              onClick={() => handleTabChange("daily")}
            >
              Daily
            </button>
            <button
              className={`btn ${activeTab === "monthly" ? "CommonColor text-white" : "btn-light"}`}
              onClick={() => handleTabChange("monthly")}
            >
              Monthly
            </button>
            <button
              className={`btn ${activeTab === "yearly" ? "CommonColor text-white" : "btn-light"}`}
              onClick={() => handleTabChange("yearly")}
            >
              Yearly
            </button>
          </div>

          {/* Date / Year Navigation */}
          <div className="d-flex justify-content-center align-items-center mb-3 position-relative">
            <Button
              variant="warning"
              className="CommonColor text-white rounded-circle me-3"
              onClick={() => changeDate(-1)}
            >
              <FaArrowLeft />
            </Button>

            {/* Clickable Date / Month / Year */}
            <h5
              className="m-0"
              style={{ cursor: "pointer", textDecoration: "underline" }}
              onClick={() => setShowDatePicker((prev) => !prev)}
            >
              {activeTab === "daily"
                ? selectedDate.toLocaleDateString()
                : activeTab === "monthly"
                ? `${String(selectedDate.getMonth() + 1).padStart(2, "0")}-${selectedDate.getFullYear()}`
                : selectedDate.getFullYear()}
            </h5>

            <Button
              variant="warning"
              className="CommonColor text-white rounded-circle ms-3"
              onClick={() => changeDate(1)}
            >
              <FaArrowRight />
            </Button>

            {/* Inline DatePicker Popup */}
            {showDatePicker && (
              <div style={{ position: "absolute", top: "40px", zIndex: 1000 }}>
                <DatePicker
                  selected={selectedDate}
                  onChange={(date) => {
                    setSelectedDate(date);
                    setShowDatePicker(false);

                    if (activeTab === "daily") fetchOrgTransactionsDaily(date);
                    else if (activeTab === "monthly") fetchOrgTransactionsMonthly(date);
                    else fetchOrgTransactionsYearly(date.getFullYear());
                  }}
                  inline
                  showMonthYearPicker={activeTab === "monthly"}
                  showYearPicker={activeTab === "yearly"}
                  dateFormat={
                    activeTab === "daily" ? "dd/MM/yyyy" : activeTab === "monthly" ? "MM/yyyy" : "yyyy"
                  }
                />
              </div>
            )}
          </div>

          {/* Totals Table */}
          <div className="text-center"><h5 className="mb-2">Organization</h5></div>
          <Table bordered hover responsive>
            <thead>
              <tr>
                <th className="text-center" colSpan={2}>Recharges</th>
                <th className="text-center" colSpan={2}>Calling</th>
              </tr>
              <tr>
                <th className="text-center">Count</th>
                <th className="text-center">Units</th>
                <th className="text-center">Count</th>
                <th className="text-center">Units</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="text-center"> {totals.recharge_count}</td>
                <td className="text-center"  style={{ color: "red" }}>{totals.recharge_amount}</td>
                <td className="text-center">{totals.calls_count}</td>
                <td className="text-center" style={{ color: "red" }}>{totals.callcharge}</td>
              </tr>
            </tbody>
          </Table>

          {/* Branch Transactions Table */}
          <div className="text-center"><h5 className="mb-2">Branches</h5></div>
          <Table bordered hover responsive>
            <thead>
              <tr>
                <th className="text-center">Branch / Area</th>
                <th className="text-center">Recharge Count</th>
                <th className="text-center">Recharge Units</th>
                <th className="text-center">Calling Count</th>
                <th className="text-center">Calling Units</th>
              </tr>
            </thead>
            <tbody>
              {(activeTab === "daily"
                ? OrgTransactionsDaily
                : activeTab === "monthly"
                ? OrgTransactionsMonthly
                : OrgTransactionsYearly
              ).map((t) => (
                <tr key={t.area_id}>
                  <td className="text-center">{t.area_name}</td>
                  <td className="text-center">{t.recharge_count}</td>
                  <td className="text-center" style={{ color: "red" }}>{t.recharge_amount}</td>
                  <td className="text-center">{t.calls_count}</td>
                  <td className="text-center" style={{ color: "red" }}>{t.callcharge}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowTransactionsModal(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Statistical Modal */}
     <Modal
  show={showOrgStatisticsticalModal}
  onHide={() => setshowOrgStatisticsticalModal(false)}
  size="lg"
  centered
>
  <Modal.Header
    className="CommonColor text-white"
    closeButton
  >
    <Modal.Title>Statistics</Modal.Title>
  </Modal.Header>

  <Modal.Body style={{ backgroundColor: "#f8f9fa" }}>
    {/* Organization Section */}
    <div className="card shadow-sm mb-4">
      <div className="card-body">
        <h5 className="text-center mb-3">Organization</h5>
        <div className="row text-center">
          <div className="col">
            <p className="mb-1 text-muted">Total Cards</p>
            <h6 className="text-danger">
              {OrgStatisticsDate?.reduce((a, b) => a + (b.total_cards_allocted || 0), 0)}
            </h6>
          </div>
          <div className="col">
            <p className="mb-1 text-muted">Cards Issued</p>
            <h6 className="text-danger">
              {OrgStatisticsDate?.reduce((a, b) => a + (b.total_cards_issued || 0), 0)}
            </h6>
          </div>
          <div className="col">
            <p className="mb-1 text-muted">Total Devices</p>
            <h6 className="text-danger">
              {OrgStatisticsDate?.reduce((a, b) => a + (b.total_devices_allocted || 0), 0)}
            </h6>
          </div>
          <div className="col">
            <p className="mb-1 text-muted">Active Today</p>
            <h6 className="text-success">
              {OrgStatisticsDate?.reduce((a, b) => a + (b.total_active_devices || 0), 0)}
            </h6>
          </div>
        </div>
      </div>
    </div>

    {/* Branch Section */}
    <div className="card shadow-sm">
      <div className="card-body">
        <h5 className="text-center mb-3">Branches</h5>
        <Table bordered hover responsive>
          <thead className="table-light">
            <tr>
              <th className="text-center">Branch Name</th>
              <th className="text-center">Total Cards</th>
              <th className="text-center">Cards Issued</th>
              <th className="text-center">Total Devices</th>
              <th className="text-center">Active Today</th>
            </tr>
          </thead>
          <tbody>
            {!OrgStatisticsDate || OrgStatisticsDate.length === 0 ? (
              <tr>
                <td colSpan="5" className="text-center text-danger">
                  No branch statistics available.
                </td>
              </tr>
            ) : (
              OrgStatisticsDate.map((branch) => (
                <tr key={branch.area_id}>
                  <td className="text-center">{branch.area_name}</td>
                  <td  className="text-center text-danger">{branch.total_cards_allocted}</td>
                  <td className="text-center text-danger">{branch.total_cards_issued}</td>
                  <td className="text-center text-danger">{branch.total_devices_allocted}</td>
                  <td className="text-center text-success">{branch.total_active_devices}</td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </div>
    </div>
  </Modal.Body>

  <Modal.Footer>
    <Button variant="secondary" onClick={() => setshowOrgStatisticsticalModal(false)}>
      Close
    </Button>
  </Modal.Footer>
</Modal>




      {/* Add Branch Modal */}
      {showModal && (
        <div
          className="modal d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <form onSubmit={handleBranchSubmit}>
                <div className="modal-header CommonColor text-white text-white">
                  <h5 className="modal-title ">Add Branch</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowModal(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="mb-2">
                    <label className="form-label">Branch Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="branch_name"
                      value={branchForm.branch_name}
                      onChange={handleInputChange}
                    />
                    {errors.name && (
                      <span className="span-error">{errors.name}</span>
                    )}
                  </div>
                  <div className="mb-2">
                    <label className="form-label">Address Line 1</label>
                    <input
                      type="text"
                      className="form-control"
                      name="address_1"
                      value={branchForm.address_1}
                      onChange={handleInputChange}
                    />
                    {errors.address1 && (
                      <span className="span-error">{errors.address1}</span>
                    )}
                  </div>
                  <div className="mb-2">
                    <label className="form-label">Address Line 2</label>
                    <input
                      type="text"
                      className="form-control"
                      name="address_2"
                      value={branchForm.address_2}
                      onChange={handleInputChange}
                    />
                    {errors.address2 && (
                      <span className="span-error">{errors.address2}</span>
                    )}
                  </div>
                  <div className="mb-2">
                    <label className="form-label">District</label>
                    <input
                      type="text"
                      className="form-control"
                      name="district"
                      value={branchForm.district}
                      onChange={handleInputChange}
                    />
                    {errors.district && (
                      <span className="span-error">{errors.district}</span>
                    )}
                  </div>
                  <div className="mb-2">
                    <label className="form-label">State</label>
                    <input
                      type="text"
                      className="form-control"
                      name="state"
                      value={branchForm.state}
                      onChange={handleInputChange}
                    />
                    {errors.state && (
                      <span className="span-error">{errors.state}</span>
                    )}
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="submit"
                    className="btn CommonColor text-white text-white"
                  >
                    Submit
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowModal(false)}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Confirmation Modal for delete organization */}
      {showDeleteModal && (
        <div
          className="modal d-block"
          tabIndex={-1}
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Are you sure you want to delete this organization?
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowDeleteModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <p>
                  Organization will be deleted permanently. If yes please write
                  the purpose of delete.
                </p>
                <input
                  type="text"
                  className="form-control"
                  value={deletePurpose}
                  onChange={(e) => setDeletePurpose(e.target.value)}
                  placeholder="Write purpose"
                />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowDeleteModal(false)}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={handleDelete}
                >
                  I Confirm To Proceed
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Organization;
